<template>
  <div id="assign-editor-dialog">
    <ipub-model :title="'Select Academic Editor'"
                width="1000px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p4 mar-b-12">Click the Blind Editors link to block access to this submission for one or more Editors.</div>
      <div class="ipub-p4 mar-b-12">
        Current decisions: The number of manuscripts currently pending decision by this academic editor across all publishers. </div>
      <site-search-group class="mar-b-20"
                         v-model.trim="search"
                         placeholder="Search by academic editor's name, email"
                         @search="getList()"
                         @clear="handleClear" />
      <div class="page-content">
        <ipub-table :columns="columns"
                    border
                    @order="onOrderChanage"
                    :dataSource="dataSource">
          <template v-slot:select="{record}">
            <ipub-radio @change="(e)=>{onCheckChange(e, record)}"
                        :checked="record.id === params.id" />
          </template>
          <template v-slot:identity="{record}">
            <div>
              <template v-if="record.ebIdentityCode">{{editorialBoard[record.ebIdentityCode]||'- - '}}</template>
              <template v-if="record.ebIdentityCode&&record.geIdentityCode">, </template>
              <template v-if="record.geIdentityCode">{{guestEditor[record.geIdentityCode]||'- - '}}</template>
            </div>
          </template>
          <template v-slot:name="{record}">
            {{record.firstName}} {{record.lastName}}
          </template>
        </ipub-table>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group.vue'
import macademic from '@/api/macademic'

const columns = [
  {
    title: '',
    enTitle: 'Select',
    width: 60,
    dataIndex: 'id',
    slot: 'select'
  },
  {
    title: '',
    enTitle: 'Editor’s role',
    width: 150,
    dataIndex: 'ebIdentityCode',
    slot: 'identity'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Current Decision',
    width: 120,
    dataIndex: 'currentDecisionNum',
    sort: true
  },
]
export default {
  components: { SiteSearchGroup },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    decisionType: {
      type: String,
      default: ''
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    detail: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      columns,
      params: {
        id: ''
      },
      search: '',
      sorted: '',
      dataSource: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      editorialBoard: 'getEditorialBoard',
      guestEditor: 'getGuestEditor',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          id: ''
        }
        this.search = ''
        this.dataSource = []
      } else {
        this.$set(this, 'params', this.inputData)
        this.getList()
      }
    }
  },
  methods: {
    onCheckChange (e, val) {
      if (e) {
        return
      }
      this.params = val
    },
    async confirm () {
      if (!this.params.id) {
        this.$message.error({
          title: 'Error',
          content: 'Please select the person to be invite to'
        })
        return
      }
      this.$emit('confirm', this.params, this.decisionType)
    },
    cancel () {
      this.$emit('cancel')
    },
    handleClear () {
      this.search = ''
      this.getList()
    },
    async getList () {
      const { id, sign, journalId } = this.detail
      this.dataSource = await macademic.person({
        manuscriptId: id,
        sorted: this.sorted, sign, journalId, keyword: this.search
      })
    },
    onOrderChanage (val) {
      this.sorted = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
